<template>
  <div class="flex flex-col items-center text-center">
    <img :src="SuccessEmailIcon" alt="Email sent" class="w-[200px] h-auto" />
    <h2 class="text-[#041A21] font-bold text-[18px] mt-4">Email sent</h2>
    <p class="text-grey-light-600 mt-2">
      Your voucher has been sent to your email.
      <br />
      Visit
      <a :href="merchantLink" target="_blank" rel="noopener noreferrer" class="text-[#3DD9AB] font-semibold">{{
        merchantName
      }}</a>
      to redeem your voucher at checkout.
    </p>
    <Button class="w-full h-12 text-base font-semibold bg-teal-700 hover:bg-teal-800 mt-6" @click="emit('done')">
      Done!
    </Button>
  </div>
</template>

<script setup lang="ts">
import SuccessEmailIcon from '@/assets/shopper/rewards/success-email.svg';
import { Button } from '@/components/ui/button';

defineProps<{
  merchantName: string;
  merchantLink: string;
}>();

const emit = defineEmits<{
  (e: 'done'): void;
}>();
</script>
